"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    erBeloepsfelt: function() {
        return erBeloepsfelt;
    },
    kortSkalSkjules: function() {
        return kortSkalSkjules;
    },
    kanIkkeLeggeTilKort: function() {
        return kanIkkeLeggeTilKort;
    },
    fjernTommeDynamiskeFelt: function() {
        return fjernTommeDynamiskeFelt;
    }
});
var _cloneDeep = /*#__PURE__*/ _interop_require_default(require("lodash/cloneDeep"));
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _set = /*#__PURE__*/ _interop_require_default(require("lodash/set"));
var _has = /*#__PURE__*/ _interop_require_default(require("lodash/has"));
var _sjekker = require("../felt/sjekker");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var harSaerskiltSkatteplikt = function(param) {
    var saerskiltSkatteplikt = param.saerskiltSkatteplikt;
    return saerskiltSkatteplikt;
};
var FELT = "felt";
var DYNAMISK_GRUPPE = "dynamiskgruppe";
var REPETERENDE_FELTGRUPPE = "repeterendefelt";
var FELTGRUPPE = "feltgruppe";
var FELT_MED_EGENSKAPER = "feltMedEgenskaper";
var BELOEPSFELT = "belopsfelt";
var erFelt = function(def) {
    return def.type === FELT;
};
var erFeltMedEgenskaper = function(def) {
    return def.type === FELT_MED_EGENSKAPER;
};
var erBeloepFeltMedEgenskaper = function(felt) {
    return erFeltMedEgenskaper(felt) && felt[BELOEPSFELT];
};
var referanseForFelt = function(felt) {
    return erFeltMedEgenskaper(felt) ? "".concat(felt.referanse, ".").concat(felt[BELOEPSFELT].referanse) : felt.referanse;
};
var erBeloepsfelt = function(def) {
    return def.referanse.endsWith(".beloep") || def.referanse.endsWith(".beloepIValuta");
};
// Skal treffe både 1) referanse="beloep" og 2) referanse="etEllerAnnet.beloep"
// Kan vurdere om 'erBeloepsfelt' skal utvides med førstnevnte
var erBeloepFeltUtenEgenskaper = function(felt) {
    return erFelt(felt) && (felt.referanse === "beloep" || erBeloepsfelt(felt));
};
function kortSkalSkjulesHvisEnForekomstOgUtenSaerskiltSkatteplikt(definisjon, forekomster, data) {
    var _definisjon_skjulHvisEnForekomstOgUtenSaerskiltSkatteplikt = definisjon.skjulHvisEnForekomstOgUtenSaerskiltSkatteplikt, skjulHvisEnForekomstOgUtenSaerskiltSkatteplikt = _definisjon_skjulHvisEnForekomstOgUtenSaerskiltSkatteplikt === void 0 ? false : _definisjon_skjulHvisEnForekomstOgUtenSaerskiltSkatteplikt;
    var harBareEnForekomst = forekomster.length === 1;
    return skjulHvisEnForekomstOgUtenSaerskiltSkatteplikt && harBareEnForekomst && !harSaerskiltSkatteplikt(data);
}
function kortSkalSkjulesGittBetingelse(definisjon, data, visningsdata) {
    // Betingelser skal ikke slås til dersom visningsdata er undefined
    if (visningsdata !== undefined) {
        if (definisjon.skjulGitt) {
            return (0, _sjekker.foelgerBetingelse)(data, definisjon.skjulGitt, visningsdata);
        }
        if (definisjon.synligGitt) {
            return !(0, _sjekker.foelgerBetingelse)(data, definisjon.synligGitt, visningsdata);
        }
    }
    return false;
}
var kortSkalSkjules = function() {
    var definisjon = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, forekomster = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, skatteplikt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, visningsdata = arguments.length > 4 ? arguments[4] : void 0;
    return kortSkalSkjulesHvisEnForekomstOgUtenSaerskiltSkatteplikt(definisjon, forekomster, data) || kortSkalSkjulesGittBetingelse(definisjon, _object_spread({
        skatteplikt: skatteplikt
    }, data), visningsdata);
};
var kanIkkeLeggeTilKort = function(definisjon, visningsdata) {
    if ((0, _has.default)(definisjon, "ikkeny")) {
        return definisjon.ikkeny;
    }
    if ((0, _has.default)(definisjon, "ikkenyGittAlle")) {
        return (0, _sjekker.foelgerAlleBetingelser)(visningsdata, definisjon.ikkenyGittAlle, visningsdata);
    }
    if ((0, _has.default)(definisjon, "nyGittAlle")) {
        return !(0, _sjekker.foelgerAlleBetingelser)(visningsdata, definisjon.nyGittAlle, visningsdata);
    }
    return false;
};
var fjernTommeDynamiskeFelt = function() {
    var korttype = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, forekomst = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _korttype_barnliste = korttype.barnliste, barnliste = _korttype_barnliste === void 0 ? [] : _korttype_barnliste;
    var klonetData = (0, _cloneDeep.default)(forekomst);
    barnliste.forEach(function(barn) {
        var feltData;
        var subforekomster = (0, _get.default)(klonetData, barn.referanse, []);
        switch(barn.type){
            case DYNAMISK_GRUPPE:
                {
                    var harBeloepsverdi = function(forekomst) {
                        var dynamiskFelt = barn.barnliste.find(function(dynamiskBarn) {
                            return dynamiskBarn.datatype === forekomst.behandlingsart;
                        });
                        // I tilfeller, spesielt i næringsspesifikasjon, så har vi beregna verdier for subforekomster som ikke har
                        // felt i visningsdefinisjonen. I disse tilfellene fjerner vi ingenting og viderefører beregna subforekomst.
                        if (!dynamiskFelt) {
                            return true;
                        }
                        if (dynamiskFelt.utfyllingsfelt) {
                            if (Array.isArray(dynamiskFelt.utfyllingsfelt)) {
                                return dynamiskFelt.utfyllingsfelt.some(function(felt) {
                                    return (0, _get.default)(forekomst, felt, "") !== "";
                                });
                            } else {
                                return (0, _get.default)(forekomst, dynamiskFelt.utfyllingsfelt, "") !== "";
                            }
                        }
                        var beloepFeltMedEgenskaperHarVerdi = function(felt) {
                            return erBeloepFeltMedEgenskaper(felt) && (0, _get.default)(forekomst, referanseForFelt(felt), "") !== "";
                        };
                        var beloepFeltHarVerdi = function(felt) {
                            return erBeloepFeltUtenEgenskaper(felt) && (0, _get.default)(forekomst, referanseForFelt(felt), "") !== "";
                        };
                        var harBeloepIValutaFeltMedVerdi = dynamiskFelt.barnliste.some(beloepFeltMedEgenskaperHarVerdi);
                        var harBeloepFeltMedVerdi = dynamiskFelt.barnliste.some(beloepFeltHarVerdi);
                        return harBeloepIValutaFeltMedVerdi || harBeloepFeltMedVerdi;
                    };
                    feltData = subforekomster.filter(function(subforekomst) {
                        return harBeloepsverdi(subforekomst) || subforekomst.erPreutfylt;
                    });
                    (0, _set.default)(klonetData, barn.referanse, feltData);
                    break;
                }
            case REPETERENDE_FELTGRUPPE:
                {
                    feltData = subforekomster.map(function(subforekomst) {
                        return fjernTommeDynamiskeFelt(barn, subforekomst);
                    });
                    (0, _set.default)(klonetData, barn.referanse, feltData);
                    break;
                }
            case FELTGRUPPE:
                klonetData = fjernTommeDynamiskeFelt(barn, klonetData);
                break;
            default:
                break;
        }
    });
    return klonetData;
};
